export const keepMenus = {
  // 菜单
  menus: [
    {path:'/flowBpmList/flowList/simplFlowDeal'}
  ]
}
